// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getDataLayer } from "@turnerBlueprint/XDL/Utilities/DataLayer";
import React from "react";

interface OwnProps {
    title: string;
    orderNumber: string;
    isVmiOrderDetailsPage?: boolean;
    isVmiOrder?: boolean;
    // Xng-Change
    isRecentOrder?: boolean;
}

type Props = OwnProps;

const OrderDetailPageTypeLink: React.FunctionComponent<Props> = ({
    title,
    orderNumber,
    isVmiOrderDetailsPage,
    isVmiOrder,
    isRecentOrder,
}) => {
    /**
     * Xng-Change
     * TSC-182
     * Push recentorders_popout event to dataLayer if a user clicked on recenet order
     * As this component is shared between recent order widgets and order history table
     * We have to check on isRecentOrder and fire this event depending on it
     * we need to use setTimeout with 100ms to make sure window.location.href
     * points to the order details page not my account
     */
    const billTo = useAppSelector(state => {
        return getBillToState(state, getSession(state).billToId).value;
    });
    const onClickHandler = isRecentOrder
        ? () => {
            setTimeout(() => {
                const dataLayer = getDataLayer();
                if (dataLayer) {
                    const googleAnalyticsData = {
                        event: "recentorders_popout",
                        text: title,
                        clickUrl: window.location.href,
                        affiliation: billTo?.companyName,
                    };
                    dataLayer.push(googleAnalyticsData);
                }
            }, 100);
        }
        : undefined;

    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: isVmiOrderDetailsPage ? "VmiOrderDetailsPage" : "OrderDetailsPage",
            overrideTitle: title,
            queryString: isVmiOrderDetailsPage
                ? `orderNumber=${orderNumber}`
                : isVmiOrder
                ? `orderNumber=${orderNumber}&isVmiOrder=true`
                : `orderNumber=${orderNumber}`,
        },
        onClickHandler,
    } as any);
};

export default OrderDetailPageTypeLink;
